export const status = {
	INITIAL: 'INITIAL',
	LOADING: 'LOADING',
	ERROR: 'ERROR',
	RESULTS: 'RESULTS',
	NO_RESULTS: 'NO_RESULTS'
};
